/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Teletext_Page_LabelInputs */



/**
* | output |
* | --- |
* | "Teletext page" |
*
* @param {Subtitle_Extract_Teletext_Page_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_teletext_page_label = /** @type {((inputs?: Subtitle_Extract_Teletext_Page_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Teletext_Page_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("page télétexte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teletext-Seite")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagina Teletext")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Страница телетекста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Página de teletexto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图文电视页面")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テレテキストページ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेलीटेक्स्ट पृष्ठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Página de teletexto")
	return /** @type {LocalizedString} */ ("Teletext page")
});